/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


(() => {
  const productIds = new Set(["10357344665817","10357345222873","10357345321177","10357345419481","10357345517785","10357345681625","10357345779929","10357345911001","10357346009305","10357346107609","10357346205913","10357346435289"]);
  const colours = {"cantaloupe":"#f4b384","neo mint":"#a3cebc","purist blue":"#8bbcd3","jet black heather":"#303438","heather blue":"#819bb6","heather red":"#b56e79","heather graphite":"#737579","heather purple":"#83708f","heather burgundy":"#815766","heather coral":"#d58a82","heather kelly green":"#59a48d","fine white":"#ffffff","fine black":"#202224","fine charcoal":"#53565a","fine navy":"#222f46","fine red":"#bd1429","fine turquoise":"#37aaba","fine kelly green":"#32824b","deep navy":"#1f3049","deep red":"#a92e39","baby blue":"#b7d2e9","vintage white":"#efe6d2","athletic heather":"#a6a6a6","neon pink":"#f279ad","aloe":"#a4b96b","vineyard":"#795567","monterey sage":"#a3ac91","royal caribe":"#377f9f","sandstone":"#c2b296","citrus":"#d8d46c","burnt orange":"#bd6c48","light green":"#99b39b","white / red":"linear-gradient(135deg,#fff 0% 50%,#bd1429 50% 100%)","white / navy":"linear-gradient(135deg,#fff 0% 50%,#222f46 50% 100%)","white / black":"linear-gradient(135deg,#fff 0% 50%,#202224 50% 100%)","sport grey / red":"linear-gradient(135deg,#aaa 0% 50%,#bd1429 50% 100%)","sport grey / navy":"linear-gradient(135deg,#aaa 0% 50%,#222f46 50% 100%)","sport grey / black":"linear-gradient(135deg,#aaa 0% 50%,#202224 50% 100%)"};
  const normalize = value => value.trim().toLowerCase().replace(/\s*\/\s*/g, ' / ');
  let pending = false;
  function apply() {
    pending = false;
    document.querySelectorAll('product-single[data-product-id], product-card[data-product-id]').forEach(product => {
      if (!productIds.has(product.dataset.productId)) return;
      product.querySelectorAll('.lma-colour-swatch, .lma-card-swatch').forEach(button => {
        const colour = colours[normalize(button.getAttribute('title') || button.getAttribute('aria-label') || '')];
        if (!colour) return;
        const target = button.classList.contains('lma-colour-swatch') ? button.querySelector('span') : button;
        if (target && target.style.getPropertyValue('--swatch') !== colour) target.style.setProperty('--swatch', colour);
      });
      if (document.documentElement.lang.toLowerCase().startsWith('fr')) {
        const column = product.querySelector('#tab_HVeR3R table thead th');
        if (column && column.textContent.trim() === 'Size') column.textContent = 'Taille';
        const title = product.querySelector('#tab_HVeR3R summary h3');
        if (title && title.textContent.trim() === 'Size Chart') title.textContent = 'Tableau des tailles';
      }
    });
  }
  function queue() {
    if (!pending) { pending = true; requestAnimationFrame(apply); }
  }
  function start() {
    apply();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queue);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

